import { useIntl } from "react-intl";

import { RanaTable } from "@nens/ranalib";
import { capitalizeFirst } from "@nens/shared-utils";

import { TableEmptyHistory } from "@/components/table-empty-history";
import { useProjectActionAllowed } from "@/hooks/use-action-allowed-in-project";
import { Profile } from "@/lib/profile";

import { UseEventsListProps, useEventsList } from "../hook/use-event-list";

export function EventsListDetailed(props: UseEventsListProps) {
  const intl = useIntl();
  const { canWriteProject } = useProjectActionAllowed();
  const { filterBy } = props;
  const { events, getRowAndLinkProps, isLoading, paginationProps, filterProps } =
    useEventsList(props);

  return (
    <RanaTable
      emptyElement={<TableEmptyHistory />}
      columnDefinitions={[
        filterBy === "project"
          ? {
              width: "table_cell_xxs",
              title: intl.formatMessage({
                id: "title.user",
                defaultMessage: "User",
              }),
            }
          : {
              width: "table_cell_xs",
              title: intl.formatMessage({
                id: "title.project",
                defaultMessage: "Project",
              }),
            },
        {
          width: "table_cell_xs",
          title: intl.formatMessage({
            id: "title.type",
            defaultMessage: "Type",
          }),
        },
        {
          width: "table_cell_l",
          title: intl.formatMessage({
            id: "title.message",
            defaultMessage: "Message",
          }),
        },
        {
          width: "table_cell_xs",
          title: intl.formatMessage({
            id: "column.created_at",
            defaultMessage: "Created at",
          }),
        },
      ]}
      tableDataIds={events.map(({ id }) => id + "")}
      isSkeleton={isLoading}
    >
      {canWriteProject && filterBy === "project" && (
        <RanaTable.Filters
          checkboxes={[
            {
              label: intl.formatMessage({
                id: "events.show_only_mine",
                defaultMessage: "Only my activity",
              }),
              ...filterProps,
            },
          ]}
        />
      )}
      <RanaTable.Container>
        <RanaTable.Header />
        <RanaTable.Body>
          {events.map((event) => {
            const { id, message, user, createdAt, entityType } = event;
            const { disabledText, to, queryParams, projectName } = getRowAndLinkProps(event);

            return (
              <RanaTable.Row
                isDisabled={!!disabledText}
                title={disabledText}
                rowId={id + ""}
                key={id}
                to={to}
                queryParams={queryParams}
              >
                <RanaTable.Cell>
                  {filterBy === "project" ? (
                    <Profile inTable user={user ?? undefined} />
                  ) : (
                    projectName
                  )}
                </RanaTable.Cell>

                <RanaTable.Cell>
                  {capitalizeFirst(entityType.replace(/_/g, " ")) + ""}
                </RanaTable.Cell>

                <RanaTable.Cell title={message}>{message}</RanaTable.Cell>
                <RanaTable.Cell>
                  {createdAt ? new Date(createdAt).toLocaleString() : "-"}
                </RanaTable.Cell>
              </RanaTable.Row>
            );
          })}
        </RanaTable.Body>
      </RanaTable.Container>
      <RanaTable.Pagination {...paginationProps} />
    </RanaTable>
  );
}
